module.exports = __webpack_public_path__ + "static/media/WhipAround_android_1_preview.fcdf1196.jpg";